<template>
  <div class="smesco-fee-setting">
    <div class="flex justify-between items-center pb-6 shadow-border-b mdmax:flex-col mdmax:gap-2">
      <div class="flex-1 flex justify-end items-center gap-2 mdmax:flex-auto mdmax:w-full">
        <LinkButton buttonText="Tambah Fee Setting" url="/smesco/fee-setting/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
    </div>
    <TableComponent :columns="columns" :list="feeSettings">
      <template slot="table-row" slot-scope="{ entry, column }">
        <div v-if="column.field === 'action'" class="flex gap-2">
          <LinkButton buttonText="Edit" :url="`/smesco/fee-setting/edit/${entry.id}`" linkType="internal" type="secondary" size="small" />
          <Button buttonText="Delete" type="delete" size="small" @action="confirmDelete(entry.id)" />
        </div>
        <span v-else-if="column.field === 'fixed_fee'">
          {{ entry[column.field] > 0 ? `Rp ${Number(entry[column.field]).toLocaleString('id-ID')}` : '-' }}
        </span>
        <span v-else-if="column.field === 'percentage_fee'">
          {{ entry[column.field] > 0 ? `${entry[column.field]}%` : '-' }}
        </span>
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="feeSettings && feeSettings.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>

    <Modal
      :modalVisible="deleteModalVisible"
      @close="closeDeleteModal"
      width="400px"
    >
      <div slot="modal-content" class="text-center">
        <h3 class="text-lg font-bold text-neutral-800 mb-2">Hapus Fee Setting</h3>
        <p class="text-neutral-600 mb-6">
          Apakah Anda yakin ingin menghapus data ini?
        </p>
        <div class="flex justify-center gap-3">
          <button
            @click="closeDeleteModal"
            class="px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium"
          >
            Batal
          </button>
          <button
            @click="deleteItem"
            class="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium"
          >
            Hapus
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import Modal from '@/components/Modal/Modal'

export default {
  components: {
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    Modal
  },
  data() {
    return {
      columns: [
        { label: 'Delivery Service', field: 'delivery_service_name' },
        { label: 'Service Package', field: 'delivery_service_package_name' },
        { label: 'Fixed Fee', field: 'fixed_fee' },
        { label: 'Percentage Fee', field: 'percentage_fee' },
        { label: 'Action', field: 'action' }
      ],
      feeSettings: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true,
      deleteModalVisible: false,
      itemToDelete: null
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/smesco/fee-setting', query: { page: 1 } })
      this.currentPage = 1
    } else {
      this.currentPage = parseInt(this.$route.query.page)
      this.getFeeSettingList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.currentPage = parseInt(val.query.page)
        this.getFeeSettingList()
      } else {
        this.$router.push({ path: '/smesco/fee-setting', query: { page: 1 } })
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getFeeSettingList() {
      this.showLoading()
      api.smesco.feeSettings({
        page: this.currentPage,
        limit: this.pageSize
      })
        .then(res => {
          if (res.data && res.data.data) {
            this.feeSettings = res.data.data.items || []
            this.totalRecords = res.data.data.pagination?.total_item || 0
          }
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/smesco/fee-setting', query: { page: page } })
    },
    confirmDelete(id) {
      this.itemToDelete = id
      this.deleteModalVisible = true
    },
    closeDeleteModal() {
      this.deleteModalVisible = false
      this.itemToDelete = null
    },
    deleteItem() {
      if (!this.itemToDelete) return
      
      this.showLoading()
      api.smesco.deleteFeeSetting(this.itemToDelete)
        .then(() => {
          this.hideLoading()
          this.$toast?.success('Data berhasil dihapus')
          this.getFeeSettingList()
        })
        .catch(() => {
          this.hideLoading()
          this.$toast?.error('Terjadi kesalahan saat menghapus data')
        })
        .finally(() => {
          this.closeDeleteModal()
        })
    }
  }
}
</script>
